<template>
  <div id="accordion">
    <div v-for="(accordion, index) in displayLabel" :key="index" class="card">
      <div
        class="card-header"
        :id="'heading' + index"
        @click="rotateIcon(accordion.id, accordion.show)"
      >
        <h5 class="mb-0">
          <button
            class="btn btn-link sticky-top"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + index"
            aria-expanded="true"
            :aria-controls="'collapse' + index"
          >
            <i
              :id="'bx-' + accordion.id"
              class="mr-1 bx"
              :class="accordion.show ? 'bxs-up-arrow' : 'bxs-right-arrow'"
            ></i>
            {{ accordion.name }}
          </button>
        </h5>
      </div>

      <div
        :id="'collapse' + index"
        class="collapse"
        :class="index == 0 ? 'show' : ''"
        :aria-labelledby="'heading' + index"
        data-bs-parent="#accordion"
      >
        <div class="card-body pt-1">
          <div class="card-body-header d-flex align-items-center">
            <!-- <span>Categories</span> -->
            <div class="inline-form">
              <input
                type="text"
                :id="accordion.id"
                placeholder="Search.."
                class="form-control name-search"
                :class="'input-search' + accordion.id"
              />
            </div>
          </div>
          <div class="category-list" v-if="show_categories">
            <div
              v-for="(category, cat) in accordion.categories"
              :key="cat"
              class="category-box"
            >
              <input
                :id="'category_' + category.id"
                type="checkbox"
                :value="category.id"
                :data-label="index"
                @click="filter(accordion.id, index)"
              />
              <label :for="'category_' + category.id">{{
                capitalize(category.name)
              }}</label>
            </div>
          </div>
          <div class="img-list">
            <div
              v-for="(thumb, ind) in accordion.textures"
              :key="ind"
              class="img-box rounded"
              :title="toUpperCase(thumb.display_name)"
              :class="[
                thumb.active &&
                accordion.start_image - 1 < ind &&
                accordion.end_image >= ind
                  ? ''  
                  : 'd-none',
                default_textures.includes(thumb.id) ? 'highlight' : '',
              ]"
              @click="
                getTexture(thumb.id, index, thumb, accordion.id + '' + thumb.id)
              "
              :id="accordion.id + '' + thumb.id"
              :texture_id="thumb.id"
            >
              <img
                :src="thumb.thumb_url"
                class="rounded p-1"
                :alt="thumb.name"
              />
              <p class="display-text p-1">
                {{ capitalize(thumb.display_name) }}
              </p>
              <!-- <div
                class="overlay"
                :class="thumb.status == 1 ? 'd-none' : ''"
              ></div> -->
            </div>
          </div>
          <!-- For showing No textures message -->
          <div
            class="row justify-content-center no-textures-found-msg"
            style="display: none"
          >
            <label>No Textures Found</label>
          </div>
          <div class="load-more-btn">
            <!-- <button class="btn btn-outline-danger">Load More</button> -->
            <nav
              aria-label="Page navigation example"
              :class="
                accordion.size == 0 || accordion.size > this.imgLimit
                  ? ''
                  : 'd-none'
              "
            >
              <ul class="pagination justify-content-end">
                <li
                  class="page-item hidden"
                  :class="accordion.page_id == 1 ? 'disabled' : ''"
                  @click="NavigateToFirstPage(accordion.id)"
                >
                  <span class="page-link" tabindex="-1"
                    ><i class="bx bx-chevrons-left"></i
                  ></span>
                </li>
                <li
                  class="page-item"
                  @click="NavigateToPreviousPage(accordion.id)"
                  :class="accordion.page_id == 1 ? 'disabled' : ''"
                >
                  <span class="page-link"
                    ><i class="bx bx-chevrons-left"></i
                  ></span>
                </li>
                <li class="page-item diabled">
                  <span class="page-link">{{
                    Math.ceil(accordion.page_id)
                  }}</span>
                </li>
                <li class="page-item" @click="NavigateToNextPage(accordion.id)"
                :class="
                    accordion.page_id ==
                    Math.ceil(accordion.amount / this.imgLimit)
                      ? 'disabled'
                      : ''
                  "
                >
                  <span class="page-link"
                    ><i class="bx bx-chevrons-right"></i
                  ></span>
                </li>
                <li
                  class="page-item hidden"
                  :class="
                    accordion.page_id ==
                    Math.ceil(accordion.amount / this.imgLimit)
                      ? 'disabled'
                      : ''
                  "
                  @click="NavigateToLastPage(accordion.id)"
                >
                  <span class="page-link"
                    ><i class="bx bx-chevrons-right"></i
                  ></span>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "../assets/scss/home/accordion.scss";

export default {
  props: ["label", "default_textures", "show_categories"],
  data() {
    return {
      search: [],
      textures: [],
      filteredTextures: [],
      textLimit: 13,
      imgLimit: 8,
      displayLabel: [],
      oldLabel: [],
      display_none_elements: [], // For making their display-one to display-visible,
      loading: false,
      host_name: undefined,

      // Query Params
      token: undefined,
      model_id: undefined,
      is_render_param: undefined,

      domainUrl: 'https://images.livefurnish.com',
      // Testing
      // domainUrl: "https://migration.livefurnish.com",
      enableTextureClick: true,  // Stop the click if one texture is clicked and didn't receive the response.
      external_user_id: '',
      TIME_OUT_TIME: 1,  // In Minutes.
      Interval : undefined
    };
  },
  watch: {
    label() {
      this.displayLabel = this.label;
      this.displayLabel.forEach((accordion) => {
        accordion.size = accordion.textures.length;
      });
    },
    displayLabel() {
      this.oldLabel = this.displayLabel;
    },
  },
  beforeCreated() {},
  methods: {
    StartTimer(){
      let time = this.TIME_OUT_TIME * 60000
      clearInterval(this.Interval)
      this.Interval = setInterval(function(){
        $.alert({
          title: '',
          content: 'Something went wrong. Please try again!'
        })
      }, time);
    },
    StopTimer(){
      clearInterval(this.Interval)
    },
    startLoader() {
      this.$emit("updateisLoadingValue", true);
    },
    stopLoader() {
      this.$emit("updateisLoadingValue", false);
    },
    showErrorMessage() {
      // window.$('.img-list .img-box ') not d-none query
    },
    handleResize() {
      if (window.innerWidth > 1500) {
        this.textLimit = 50;
      } else {
        this.textLimit = 13;
      }

      // if (window.innerWidth < 700) {
      //   this.imgLimit = 6;
      // } else {
      //   this.imgLimit = 8;
      // }
    },
    capitalize(s) {
      JSON.stringify(s);
      return s.toLowerCase();
    },
    toUpperCase(str) {
      return str.toUpperCase();
    },
    Search(event) {
      let search = window.$.trim(event.target.value);
      let id = event.target.id;
      this.displayLabel = this.oldLabel;

      this.displayLabel.forEach((accordion) => {
        if (accordion.id == id) {
          accordion.textures.forEach((thumb) => {
            if (
              thumb.display_name.toLowerCase().indexOf(search.toLowerCase()) >
              -1
            ) {
              thumb.active = true;
            } else {
              thumb.active = false;
            }
          });
          if (search === "") {
            accordion.page_id = 1;
            window.$(".load-more-btn").removeClass("d-none");
            let screenWidht = window.$(window).width();
            let screenHeight = window.$(window).height();
            accordion.start_image = 0;
            accordion.end_image = 7;
            // if (parseInt(screenWidht) < parseInt(screenHeight)) {
            //   accordion.start_image = 0;
            //   accordion.end_image = 5;
            // } else {
            //   accordion.start_image = 0;
            //   accordion.end_image = 7;
            // }
          } else {
            accordion.start_image = 0;
            accordion.end_image = accordion.textures.length;
            window.$(".load-more-btn").addClass("d-none");
          }
        }
      });
    },
    filter(label_id, index) {
      let category_ids = [];
      window.$("input:checkbox[type=checkbox]:checked").each(function () {
        if (index === window.$(this).data("label")) {
          category_ids.push(window.$(this).val());
        }
      });
      let searchParams = new URLSearchParams(window.location.search);
      let name = window.$(".input-search" + label_id).val();
      let closest_not_found_message = window
        .$(".collapse" + label_id)
        .find(".no-textures-found-msg");
      axios
        .get(
          this.domainUrl +
            "/three-sixty/api/viewer/textures/?label=" +
            label_id +
            "&category=" +
            category_ids.toString() +
            "&token=" +
            this.token +
            "&name=" +
            name +
            "&host_name=" +
            this.host_name +
            "&ext=" + this.external_user_id
        )
        .then((response) => {
          let tempArray = [];
          let tempResponse = [];
          response.data.results.forEach((texture) => {
            if (tempArray.indexOf(texture.id) > -1 != true) {
              tempArray.push(texture.id);
              texture.active = true;
              tempResponse.push(texture);
            }
          });

          // Showing not found message if results are empty
          if (response.data.results.length === 0) {
            closest_not_found_message.show();
          } else {
            closest_not_found_message.hide();
          }

          // if (category_ids.length > 0) {
          //   this.displayLabel.forEach((label, li) => {
          //     if (li === index) {
          //       label.textures = tempResponse;
          //     }
          //   });
          //   this.displayLabel.forEach((accordion) => {
          //     accordion.size = accordion.textures.length;
          //   });
          // } else {
          //   this.displayLabel = this.label;
          //   this.displayLabel.forEach((accordion) => {
          //     accordion.size = accordion.textures.length;
          //   });
          // }
          this.displayLabel.forEach((label, li) => {
            if (li === index) {
              label.textures = tempResponse;
            }
          });
          this.displayLabel.forEach((accordion) => {
            if (accordion.id == label_id) {
              accordion.textures.forEach((thumb) => {
                if (
                  thumb.display_name.toLowerCase().indexOf(
                    window
                      .$("input.input-search" + label_id)
                      .val()
                      .toLowerCase()
                  ) > -1
                ) {
                  thumb.active = true;
                } else {
                  thumb.active = false;
                }
              });
            }
          });

          this.displayLabel.forEach((accordion) => {
            accordion.size = accordion.textures.filter(
              (thumb) => thumb.active === true
            ).length;
            accordion.page_id = 1;
            let screenWidht = window.$(window).width();
            let screenHeight = window.$(window).height();
            if (parseInt(screenWidht) < parseInt(screenHeight)) {
              accordion.start_image = 0;
              accordion.end_image = 5;
            } else {
              accordion.start_image = 0;
              accordion.end_image = 7;
            }
          });

          // To update the search values
          window.$(".input-search" + label_id).trigger("keyup");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    NavigateToFirstPage(texture_id) {
      this.label.forEach((thumb) => {
        if (thumb.id == texture_id) {
          thumb.start_image = 0;
          thumb.end_image = this.imgLimit - 1;
          thumb.page_id = 1;
        }
      });
    },
    NavigateToLastPage(texture_id) {
      this.label.forEach((thumb) => {
        if (thumb.id == texture_id) {
          // thumb.start_image = thumb.amount - 8;
          // thumb.end_image = thumb.amount;
          // thumb.page_id = Math.ceil(thumb.amount / 8) - 1;
          if (thumb.page_id < Math.ceil(thumb.amount / this.imgLimit)) {
            this.label.forEach((thumb) => {
              if (
                thumb.id == texture_id &&
                thumb.page_id < Math.ceil(thumb.amount / this.imgLimit)
              ) {
                thumb.page_id = Math.ceil(thumb.amount / this.imgLimit);
                thumb.start_image =
                  thumb.amount - (thumb.amount % this.imgLimit);
                thumb.end_image =
                  thumb.amount -
                  (thumb.amount % this.imgLimit) +
                  this.imgLimit -
                  1;

                if (thumb.amount % this.imgLimit == 0) {
                  this.NavigateToPreviousPage(texture_id);
                }
              }
            });
          }
        }
      });
    },
    NavigateToPreviousPage(texture_id) {
      this.label.forEach((thumb) => {
        if (thumb.id == texture_id && thumb.page_id > 1) {
          thumb.page_id = thumb.page_id - 1;
          thumb.start_image = thumb.start_image - this.imgLimit;
          thumb.end_image = thumb.end_image - this.imgLimit;
        }
      });
    },
    NavigateToNextPage(texture_id) {
      this.label.forEach((thumb) => {
        if (
          thumb.id == texture_id &&
          thumb.page_id < Math.ceil(thumb.amount / this.imgLimit)
        ) {
          thumb.page_id = thumb.page_id + 1;
          thumb.start_image = thumb.start_image + this.imgLimit;
          thumb.end_image = thumb.end_image + this.imgLimit;
        }
      });
    },
    getTexture(id, index, texture, element_id) {
      if ($('.zoom-display.d-none').length === 0){
        this.$emit("callChangeImageMethod");
      }
      if (!this.enableTextureClick){
        return false
      }
      this.enableTextureClick = false;

      console.log("Inside textures", texture)
      let old_selected_texture_id = $('#' + element_id).closest('.img-list').find('.img-box.highlight').attr('id')
      $('#' + element_id).closest('.img-list').find('.img-box').removeClass('highlight')
      $('#' + element_id).addClass('highlight')

      this.textures = $('.img-box.highlight').map(function () {
                return parseInt($(this).attr('texture_id'))
            }).get()

      // Made the is_render dynamic
      let is_render = this.is_render_param;

      let render_status = undefined;
      if (is_render) {
        render_status = texture.render_status;
      } else {
        render_status = texture.preview_status;
      }

      const data = {
        textures: this.textures,
        is_render: is_render,
        basemodel: this.model_id,
      };
      this.$emit(
        "updateSelectedTexturesData",
        JSON.parse(JSON.stringify(data))
      );
      this.startLoader();

      this.StartTimer()
      axios
        .post(
          this.domainUrl +
            "/three-sixty/api/merge/?token=" +
            this.token +
            "&host_name=" +
            this.host_name +
            "&ext=" + this.external_user_id,
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.StopTimer()
          this.enableTextureClick = true
          this.stopLoader();
          if (response.data.success) {
            console.log("Inside merge data", response)
            let results = response.data.results;

            // Updating allImages for Single merge zoom
            this.$emit(
              "updateAllImages",
              results.images
            );
            

            this.$emit(
              "updateSelectedTextureMergeId",
              response.data.results.unique_id
            );

            // For updatingthe infor of the watermark and MetaData
            this.$emit("updateMetaDataAndWaterMarkInfo", results);


            let basemodel_data = results.basemodel_data;
            let bg_color = undefined;
            if (basemodel_data.is_bg_color) {
              bg_color = basemodel_data.bg_color;
            }
            this.$emit("updateFullScreenBackgroundColor", bg_color);

            return this.$emit("changedImages", response.data.results);
          } else {
            // console.log("removeClass", element_id, $("#" + element_id));
            // $("#" + element_id).removeClass("highlight");
            console.log("old_selected_texture_id", old_selected_texture_id)
            // Resetting the old texture to selected.
            $('#' + element_id).closest('.img-list').find('.img-box').removeClass('highlight')
            $('#' + old_selected_texture_id).addClass('highlight')
            $.alert({
              title: "",
              content: response.data.message,
            });
          }
        })
        .catch((err) => {
          this.StopTimer()
          this.stopLoader();
          this.enableTextureClick = true
          this.$emit("showUnauthorizedError", err);
        });
    },
    rotateIcon(id, show) {
      this.label.forEach((thumb) => {
        if (thumb.id == id) {
          thumb.show = !show;
        } else {
          thumb.show = false;
        }
      });
    },
  },
  created() {
    let that = this;
    let host_name =
      window.location != window.parent.location
        ? document.referrer
        : document.location.href;
    this.host_name = new URL(host_name).host;
    // this.host_name = '360-test.livefurnish.com'

    const params = window.location.search.split("?")[1].split("/"); // 0: Token, 1: model_id, 2: is_render
    this.token = params[0];
    this.model_id = params[1];
    let is_render = params[2];
    this.external_user_id = params[3];

    if (is_render === "1") {
      this.is_render_param = true;
    } else {
      this.is_render_param = false;
    }

    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    window.$(document).on("keyup", ".name-search", function (event) {
      that.Search(event);
    });
  },

  mounted() {
    this.textures = this.default_textures;

    window.$(document).ready(function () {
      let screenWidht = window.$(window).width();
      let screenHeight = window.$(window).height();

      if (parseInt(screenWidht) < parseInt(screenHeight)) {
        window.$("#accordion .card .card-body .img-list").css({
          height: "22.3vh",
        });
      } else {
        window.$("#accordion .card .card-body .img-list").css({
          height: "22.3vw",
        });
      }
    });
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
